import React from 'react';

export const xIcon = () => {
  return (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="10" fill="#3F1113"/>
<path d="M12 0C18.627 0.000229599 24 5.37295 24 12C24 18.627 18.627 23.9998 12 24C5.37281 24 0 18.6272 0 12C2.88447e-07 5.37281 5.37281 0 12 0ZM10.4873 12.7832L5.09961 19.0449H6.31738L11.0273 13.5703L14.79 19.0449H18.8994L13.3125 10.9141L18.4492 4.94336H17.2324L12.7715 10.1279L9.20898 4.94336H5.09961L10.4873 12.7832ZM17.2324 18.1709H15.3633L6.75586 5.85938H8.62598L17.2324 18.1709Z" fill="white"/>
</svg>

  );
};
